/* eslint-disable dot-notation */

export function registerLooksGenerators(gen) {
  gen.forBlock['looks_show'] = (block) => {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    return `window.__PHASER_SPRITES__['${sprite}'].visible = true;\n`
  }

  gen.forBlock['looks_hide'] = (block) => {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    return `window.__PHASER_SPRITES__['${sprite}'].visible = false;\n`
  }

  gen.forBlock['looks_scale'] = (block) => {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    const scale = (block.getFieldValue('SCALE') || 50) / 100
    return `window.__PHASER_SPRITES__['${sprite}'].setScale(${scale});\n`
  }

  gen.forBlock['looks_say'] = (block) => {
    const text = JSON.stringify(block.getFieldValue('TEXT') || 'Halo!')
    const seconds = block.getFieldValue('SECONDS') || 2
    return `say(${text}, ${seconds});\n`
  }
}
